<template>
    <div class="row fullHeight">
        <div class="mypage_mainwindow">
            <div class="cardwindow mb-3 mx-3">
                <MypageHeader
                    :member_no="member_no"
                    :full_name="member_name"
                />
                <div class="graywindow">
                    <div class="mt-3 graywindow_sp row row-notMx">
                        <div>
                            <p class="mb-4">
                                <span class="description">バーコードの読み取りができない場合、お使いの端末の明るさを最大に変更してください。</span>
                            </p>
                        </div>
                        <slot></slot>
                    </div>
                    <slot name="listBackBtn"></slot>
                </div>
            </div>
            <div class="barcode-container mb-3 mx-3">
                <div class="footer_display_on spBarcode text-center row no-gutters">
                    <MyPageBarCode ref="barcode" v-bind:golfGroupCode="golf_group_code"/>
                </div>
            </div>
            <div class="barcode-container mb-3 mx-3">
                <div class="footer_display_on spBarcode text-center row no-gutters">
                    <MyPageQrCode ref="qrcode" v-bind:golfGroupCode="golf_group_code"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MypageHeader from '../mypage/MypageHeader';
import MyPageQrCode from '../components/MyPage/MyPageQrCode';
import MyPageBarCode from '../components/MyPage/MyPageBarCode';

export default {
    components: {
        MyPageQrCode,
        MyPageBarCode,
        MypageHeader,
    },
    data () {
        return {
            member_name: '',
            member_no: '',
            golf_group_code: process.env.MIX_GROUP_CODE,
        };
    },
    created () {
        this.initialize();
    },
    mounted: function () {
        // ログインしている会員番号を取得後に表示するバーコードとQRを作成する（各コンポーネントの読み込み時では、会員番号を取得できていないため正しく表示できない）
        this.$refs.barcode.makeDisplayCode(this.member_no);
        this.$refs.qrcode.makeDisplayCode(this.member_no);
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize () {
            this.member_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
            this.member_no = this.$store.state.auth.loginMember.member_no;
        },
        BackMyPage: function (){
            // マイページトップ画面へ遷移
            this.$router.push({ path: '/mypage' });
        },
    }
}
</script>
